import { render, staticRenderFns } from "./courseEdit.vue?vue&type=template&id=cc397320&scoped=true"
import script from "./courseEdit.vue?vue&type=script&lang=js"
export * from "./courseEdit.vue?vue&type=script&lang=js"
import style0 from "./courseEdit.vue?vue&type=style&index=0&id=cc397320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc397320",
  null
  
)

export default component.exports